import { useNavigate, useOutletContext } from 'react-router-dom';
import styled from 'styled-components';
import { parkingFestivalList } from 'src/assets/database/parkingData';
import { IFestivalOutlet } from 'src/interfaces/overview.interface';
// title, subtitle 필요

export default function UserFooter() {
  const navigate = useNavigate();
  const { festivalId } = useOutletContext<IFestivalOutlet>();

  const currentFestival = parkingFestivalList.find(
    f => f.festivlaId === festivalId,
  )?.data;

  return (
    <FooterContainer>
      <Logout onClick={() => navigate('/parking/admin/login')}>
        관리자 페이지 접속
      </Logout>
      <FestivalTitle>{currentFestival?.title || '페스티맵 제작'}</FestivalTitle>
      <ServiceName>{currentFestival?.subtitle || '페스티맵 제작'}</ServiceName>
    </FooterContainer>
  );
}

const FooterContainer = styled.div`
  width: 100%;
  background: #fff;

  padding: 0 20px 20px 20px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.05);
  margin-top: 12px;
  display: flex;
  flex-direction: column;
`;

const Logout = styled.div`
  margin: 16px auto 12px auto;
  display: flex;
  width: 200px;
  padding: 9px 16px;
  justify-content: center;
  align-items: center;
  gap: 4px;
  border-radius: 12px;
  background: #f2f2f5;

  color: #111;
  font-size: 15px;
  font-style: normal;
  font-weight: 600;
  line-height: 22px; /* 146.667% */
  letter-spacing: -0.375px;
`;

const FestivalTitle = styled.div`
  color: #101010;
  text-align: center;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px; /* 150% */
  letter-spacing: -0.4px;
`;

const ServiceName = styled.div`
  color: #505050;
  text-align: center;
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px; /* 153.846% */
  letter-spacing: -0.325px;
`;
